// components/AppBar.tsx
import React from "react";
import AddIcon from "@mui/icons-material/Add";
import FolderDeleteIcon from "@mui/icons-material/FolderDelete";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useRouter } from "next/router";
import { Button, ButtonGroup, StyledAppBar, StyledToolbar } from "./FolderAppBar.styled";
interface AppBarProps {
  currentFolderId: string | null;
  onCreateFolder: () => void;
  onDeleteFolder: () => void;
}
const AppBarComponent: React.FC<AppBarProps> = ({
  currentFolderId,
  onCreateFolder,
  onDeleteFolder
}) => {
  const router = useRouter();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const handleCreateMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCreateMenuClose = () => {
    setAnchorEl(null);
  };
  const handleCreateEntity = (type: string) => {
    router.push(`/${type}?folderId=${currentFolderId}`);
    handleCreateMenuClose();
  };
  return <StyledAppBar position="static" data-sentry-element="StyledAppBar" data-sentry-component="AppBarComponent" data-sentry-source-file="index.tsx">
            <StyledToolbar variant="dense" data-sentry-element="StyledToolbar" data-sentry-source-file="index.tsx">
                <ButtonGroup data-sentry-element="ButtonGroup" data-sentry-source-file="index.tsx">
                    <Button onClick={onCreateFolder} data-sentry-element="Button" data-sentry-source-file="index.tsx">
                        <AddIcon data-sentry-element="AddIcon" data-sentry-source-file="index.tsx" /> Create New Folder
                    </Button>
                    <Button onClick={handleCreateMenuClick} data-sentry-element="Button" data-sentry-source-file="index.tsx">
                        <MoreVertIcon data-sentry-element="MoreVertIcon" data-sentry-source-file="index.tsx" /> Create New Image
                    </Button>
                    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCreateMenuClose} data-sentry-element="Menu" data-sentry-source-file="index.tsx">
                        <MenuItem onClick={() => handleCreateEntity("battlemap")} data-sentry-element="MenuItem" data-sentry-source-file="index.tsx">
                            Battlemap
                        </MenuItem>
                        <MenuItem onClick={() => handleCreateEntity("character")} data-sentry-element="MenuItem" data-sentry-source-file="index.tsx">
                            Character
                        </MenuItem>
                        <MenuItem onClick={() => handleCreateEntity("item")} data-sentry-element="MenuItem" data-sentry-source-file="index.tsx">
                            Item
                        </MenuItem>
                        <MenuItem onClick={() => handleCreateEntity("landscape")} data-sentry-element="MenuItem" data-sentry-source-file="index.tsx">
                            Landscape
                        </MenuItem>
                        <MenuItem onClick={() => handleCreateEntity("monster")} data-sentry-element="MenuItem" data-sentry-source-file="index.tsx">
                            Monster
                        </MenuItem>
                        <MenuItem onClick={() => handleCreateEntity("npc")} data-sentry-element="MenuItem" data-sentry-source-file="index.tsx">
                            NPC
                        </MenuItem>
                    </Menu>
                </ButtonGroup>
                {currentFolderId && <Button onClick={onDeleteFolder}>
                        <FolderDeleteIcon /> Delete Folder
                    </Button>}
            </StyledToolbar>
        </StyledAppBar>;
};
export default AppBarComponent;